import { createTheme } from '@mui/material/styles';

// Public theme for the homepage - optimized for marketing and conversion
export const publicTheme = createTheme({
  palette: {
    primary: {
      main: '#619648', // Careva brand green
      light: '#8BC574',
      dark: '#4A7A38',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#DC6B4E', // Warm coral (complementary to green)
      light: '#F08A6E',
      dark: '#B84A2E',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
    text: {
      primary: '#212121',
      secondary: '#757575',
    },
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 700,
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 600,
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      lineHeight: 1.6,
    },
    body2: {
      lineHeight: 1.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 8,
          padding: '8px 24px',
        },
        contained: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          '&:hover': {
            boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: '3.5rem',
          '@media (max-width:600px)': {
            fontSize: '2.5rem',
          },
        },
        h2: {
          fontSize: '2.5rem',
          '@media (max-width:600px)': {
            fontSize: '2rem',
          },
        },
      },
    },
  },
});

// Dark theme variant for public pages (if needed)
export const publicDarkTheme = createTheme({
  ...publicTheme,
  palette: {
    ...publicTheme.palette,
    mode: 'dark',
    primary: {
      main: '#9FD67F', // Light green for dark mode
      light: '#B4E89A',
      dark: '#7AB85F',
      contrastText: '#1A3D1A',
    },
    secondary: {
      main: '#F08A6E', // Light coral for dark mode
      light: '#FFA88C',
      dark: '#DC6B4E',
      contrastText: '#3D1A0F',
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b3b3b3',
    },
  },
});
